<mat-card class="settings-card">
  <mat-tab-group>
    <!-- TAB 1: User Management -->
    <mat-tab label="Manage Users">
       <div class="user-list-scroll-wrapper">
      <div class="user-list">
        <mat-table [dataSource]="users" class="mat-elevation-z2 full-width-table">

        <!-- Name -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
          <mat-cell *matCellDef="let user" [matTooltip]="user.firstName + ' ' + user.lastName">
            {{ user.firstName }} {{ user.lastName }}
          </mat-cell>
        </ng-container>

        <!-- Email -->
        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
          <mat-cell *matCellDef="let user" [matTooltip]="user.email"> {{ user.email }} </mat-cell>
        </ng-container>

        <!-- Phone -->
        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef> Phone </mat-header-cell>
          <mat-cell *matCellDef="let user" [matTooltip]="user.phone"> {{ formatPhone(user.phone) }} </mat-cell>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
          <mat-cell *matCellDef="let user">
            <mat-chip [color]="user.status ? 'primary' : 'warn'" selected>
              {{ user.status ? 'Active' : 'Inactive' }}
            </mat-chip>
          </mat-cell>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
          <mat-cell *matCellDef="let user" class="actions-cell">

        <!-- Toggle Activate/Deactivate -->
        <button mat-icon-button
                [disabled]="!admin"
                [color]="user.status ? 'warn' : 'primary'"
                (click)="toggleUserStatus(user)"
                [matTooltip]="user.status ? 'Deactivate' : 'Activate'">
          <mat-icon>{{ user.status ? 'lock' : 'lock_open' }}</mat-icon>
        </button>

        <!-- Edit Permissions -->
        <button mat-icon-button 
                [disabled]="!admin"
                color="accent"
                (click)="openPermissionsDialog(user)"
                matTooltip="Edit Permissions">
          <mat-icon>security</mat-icon>
        </button>

        <!-- View -->
        <!-- <button mat-icon-button color="primary"
                (click)="viewUser(user)" matTooltip="View Details">
          <mat-icon>visibility</mat-icon>
        </button> -->

        <!-- Delete -->
        <!-- <button mat-icon-button color="warn"
                (click)="removeUser(user)" matTooltip="Delete">
          <mat-icon>delete</mat-icon>
        </button> -->

      </mat-cell>
    </ng-container>

        <!-- Header and Rows -->
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>
    </div>
    </mat-tab>

    <!-- TAB 2: Add User -->
    <mat-tab label="Add User" [disabled]="!admin">
      <form class="add-user-form" (ngSubmit)="addUser()">
        <div class="form-grid">
          <mat-form-field appearance="outline">
            <mat-label>First Name</mat-label>
            <input matInput [(ngModel)]="newUser.firstName" name="firstName" required />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Last Name</mat-label>
            <input matInput [(ngModel)]="newUser.lastName" name="lastName" required />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput type="email" [(ngModel)]="newUser.email" name="email" required />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Phone Number</mat-label>
            <input matInput type="tel" [(ngModel)]="newUser.phone" name="phone" required />
          </mat-form-field>
        </div>

        <h3>Permissions</h3>
        <div class="permissions">
          <mat-checkbox [(ngModel)]="newUser.permissions.viewConversations" name="viewConversations">
            View Conversations
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="newUser.permissions.sendMessages" name="sendMessages">
            Send Messages
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="newUser.permissions.viewInsights" name="viewInsights">
            View Insights
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="newUser.permissions.manageUsers" name="manageUsers">
            Manage Users
          </mat-checkbox>
        </div>

        <button mat-raised-button color="primary" type="submit" [disabled]="isLoading">
          <mat-icon *ngIf="!isLoading">person_add</mat-icon> Add User
           <mat-spinner *ngIf="isLoading" diameter="24"></mat-spinner>
        </button>
      </form>
    </mat-tab>
  </mat-tab-group>
</mat-card>